export function getNextLetter(letter) {
    if ((letter.length === 1 && letter === 'z')) {
        return letter;
    } else if (letter.length !== 1) {
        throw new Error('The argument must be a single letter');
    }
    return String.fromCharCode(letter.charCodeAt(0) + 1);
}